import { useTranslation } from "react-i18next";
import { pick } from "src/utils/localize";

// МАРШРУТ ТУРА КАК СХЕМА ЛИНИИ.
//
// Раньше это была строка «Токио – Фудзи – Киото – Осака – Нара»: правильная,
// но неотличимая от любого другого текста на странице. Между тем маршрут —
// это первое, что человек ищет глазами после цены, и в Японии у него есть
// свой узнаваемый язык: схема железнодорожной линии, где станции — кружки на
// нити, а конечные отмечены крупнее.
//
// Так и рисуем: тонкая линия, точка на каждом городе, первая и последняя —
// с ободком (это начало и конец поездки), названия под точками. На узком
// экране схема переносится на вторую строку и остаётся читаемой.
//
// Всё нарисовано вёрсткой, без картинок: линия — это градиентная полоска,
// точки — кружки. Порядок городов задаётся в админке.

// Точка города. Внешняя коробка у всех одной высоты (12 px), а кружок
// внутри — разного размера: так центры точек и отрезков линии совпадают
// ровно, независимо от того, конечная это станция или промежуточная.
const Dot = ({ terminal }) => (
  <span aria-hidden="true" className="flex h-3 w-3 items-center justify-center">
    <span
      className={
        terminal
          ? // конечная: кружок с ободком, как на схемах пересадок
            "block h-3 w-3 rounded-full border-2 border-kj-gold bg-kj-dark"
          : "block h-2 w-2 rounded-full bg-kj-sky"
      }
    />
  </span>
);

export default function TourRoute({ route, className = "" }) {
  const { t, i18n } = useTranslation();
  const stops = (route || []).map((stop) => pick(stop, i18n.language)).filter(Boolean);

  if (stops.length === 0) return null;

  return (
    <div className={className}>
      <h3 className="text-xs font-bold uppercase tracking-[0.12em] text-kj-sub">
        {t("tour.routeTitle")}
      </h3>

      <ol className="mt-3 flex flex-wrap items-start gap-y-3">
        {stops.map((stop, i) => {
          const terminal = i === 0 || i === stops.length - 1;
          return (
            <li key={`${stop}-${i}`} className="flex items-start">
              {/* Отрезок линии перед городом. У первого его нет — линия
                  начинается вместе с поездкой. */}
              {i > 0 && (
                <span
                  aria-hidden="true"
                  className="mt-[6px] h-px w-6 sm:w-10 flex-none bg-gradient-to-r from-kj-sky/40 via-kj-sky/70 to-kj-sky/40"
                />
              )}
              <span className="flex flex-col items-center gap-1.5 px-1.5">
                <Dot terminal={terminal} />
                <span
                  className={`whitespace-nowrap text-sm sm:text-base leading-none ${
                    terminal
                      ? "font-extrabold text-kj-ink"
                      : "font-semibold text-kj-sub"
                  }`}
                >
                  {stop}
                </span>
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
